import React from "react";
import cx from "classnames";
import FaCheck from "react-icons/lib/fa/check";
import { getBadgeImage } from "../../../Badging/utils";

export default function BadgeCell(props) {
  const {badges, selected} = props;

  if (!badges || !badges[0]) return null;

  const sorted = badges.sort(sortFn)
  const badge = sorted[0];

  const { awarded, locale, rewardLevelId } = badge;
  
  let badgeClass = cx({
    'badgeImg': true,
    'badgeAwarded': awarded,
  });

  const badgeSrc = getBadgeImage(locale, rewardLevelId)

  return (
    <div className='badgeImgWrap'>
      <img className={badgeClass} src={badgeSrc} onClick={props.onClick} />
      {selected && <div className='badgeSelectedIndicator' />}
      {awarded && <FaCheck className='badgeAwardedCheckmark' />}
    </div>
  )

  function sortFn(a, b) {
    if (props.sort === 'byDate') return new Date(b.createdAt) - new Date(a.createdAt)
    return badgePriority[a.rewardLevelId] - badgePriority[b.rewardLevelId]
  }
}

const badgePriority = {
  WIZARD: 1,
  GURU: 2,
  TITAN: 3,
  RANGER: 4,
  BUDDY: 5,
  PAL: 6,
}